module.exports = __webpack_public_path__ + "img/agreement-form.61cc7d30.png";